/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { SignUpService } from 'lib';
import { ISignUpUser } from 'types';
import { SignUp } from './types';

const signUpUser = SignUpService.getUser();
const initialState: ISignUpUser | null = signUpUser;

export const signUpUserReducer: Reducer<ISignUpUser | null> = (state = initialState, action) => {
  switch (action.type) {
    case SignUp.CREATE_SIGN_UP_USER_SUCCESS:
    case SignUp.UPDATE_SIGN_UP_USER_SUCCESS:
    case SignUp.VERIFY_SIGN_UP_USER_IDENTITY_SUCCESS:
    case SignUp.COMPLETE_SIGN_UP_SUCCESS: {
      SignUpService.setUser(action.payload); // update sign-up user in sessionStorage for persist purposes
      return {
        ...state,
        ...action.payload,
      };
    }
    case SignUp.CLEAR_SIGN_UP_USER: {
      SignUpService.clearUser(); // clear sign-up user from sessionStorage
      return null;
    }
    default: {
      return state;
    }
  }
};
